import { render, staticRenderFns } from "./ToggleCollapsable.vue?vue&type=template&id=9348ac0a&scoped=true&"
import script from "./ToggleCollapsable.vue?vue&type=script&lang=js&"
export * from "./ToggleCollapsable.vue?vue&type=script&lang=js&"
import style0 from "./ToggleCollapsable.vue?vue&type=style&index=0&id=9348ac0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9348ac0a",
  null
  
)

export default component.exports